import { render, staticRenderFns } from "./ExpiryMessage.vue?vue&type=template&id=1d138dfa"
import script from "./ExpiryMessage.vue?vue&type=script&lang=js"
export * from "./ExpiryMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports